import React from "react";
import { Link } from "react-router-dom";

export const MiniContactBar = () => {
  return (
    <div className="mini-container">
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.linkedin.com/in/derek-williams-658580aa/"
        className="social-links"
      >
        <i style={{ fontSize: 30 }} className="fab fa-linkedin" />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://github.com/dwilli77"
        className="social-links"
      >
        <i style={{ fontSize: 30, marginLeft: 10 }} className="fab fa-github" />
      </a>
      <div style={{display: 'inline', marginLeft:10, color:'#fb8c00'}}>
        <Link to="/contact">
          <i
            className="material-icons prefix"
            style={{ fontSize: 20, color: "#fb8c00" }}
          >
            email
          </i>
          <p style={{ display: "inline-block", fontSize: 18, color: '#ccc'}}>
            &nbsp;dwilli77@gmail.com
          </p>
        </Link>
      </div>
      <div style={{display: 'inline', marginLeft:10}}>
            <i className="material-icons prefix" style={{fontSize:20, color:'#fb8c00'}}>phone</i>
            <p style={{display: 'inline-block', marginTop:0, fontSize:18, color: '#ccc'}}>&nbsp;865-221-9465</p>
          </div>
    </div>
  );
};
